import { Component, OnInit } from '@angular/core';
import { PlatformCommand } from '@shared/commands/command-base';
import {IDialogView} from "@shared/components/ok-cancel-dialog/ok-cancel-dialog.component";
import { Api } from '@shared/constants/common-field.constants';
import {DialogModel} from "@shared/models/dialog.model";

@Component({
    standalone: false,
    selector: 'app-cbc-localentity-required-file-editor',
  templateUrl: './cbc-localentity-required-file-editor.component.html',
  styleUrls: ['./cbc-localentity-required-file-editor.component.scss']
})
export class CbcLocalEntityRequiredFileEditorComponent implements OnInit, IDialogView {

  data: DialogModel;
  item: any;
  fieldDefinition: any;

  IsLocalFileRequiredOverwrite: boolean = false;
  overwrittenValue: any;
  hasAutoExchangeValue: any;
  surrogateRequired: any;
  localEntityRequiredDefaultFile: any;

  constructor() { }

  ngOnInit(): void {
    this.item = this.data.input['item'];
    this.fieldDefinition = this.data.input['fieldDefinition'];
    this.hasAutoExchangeValue = this.item.cells['CbCAutomaticExchange'].displayText;
    this.surrogateRequired = this.item.cells['SurrogateRequired'].displayText;
    this.localEntityRequiredDefaultFile = this.item.cells['LocalEntityRequiredDefaultValue'].displayText;
    const LocalFileRequiredOverwriteValue = this.item.cells['LocalFileRequiredOverwritten']?.displayText; // checkbox is check or not.
    this.overwrittenValue = this.item.cells[this.fieldDefinition.key].displayText; // cell value
    if(LocalFileRequiredOverwriteValue === 'Yes'){
      this.IsLocalFileRequiredOverwrite = true;
    }
  }


  onOkClicked(): any {
    this.data.input.NextExecutionCommand = this.getExecutionCommand();
    this.data.input.HasUpdate = this.HasUpdate();
    return true;
  }
  getExecutionCommand(){
    const command = new PlatformCommand('UpdateCbCComplianceCommand', Api.DueDateTracker);
    command.setValue('LocalEntityRequiredCell', true);
    command.setValue('ItemId', this.item.id);
    command.setValue('LocalFileRequired', this.overwrittenValue === 'Yes');
    command.setValue('LocalFileRequiredOverriten', this.IsLocalFileRequiredOverwrite);
    command.setValue('StrategyType', 'UpdateCbCLocalEntityFileRequiredStrategy');
    command.projectId = '[PROJECT_ID]';
    return command;
  }

  private HasUpdate(): boolean {
    if(this.overwrittenValue !== this.item.cells[this.fieldDefinition.key].displayText) return true;
    else if(this.IsLocalFileRequiredOverwrite !== this.ConvertBoolean(this.item.cells['LocalFileRequiredOverwritten'].displayText)){
      return true;
    }
    return false;
  }

  private ConvertBoolean = (value: any): boolean => value === 'Yes';

}
